import axios from "axios";
import request from "../request";

export const presigneUrl = (files, type) =>
  request.post("upload/presign-url", { files, type }).then((res) => res);

export const deleteFiles = (files, type) =>
  request.post("upload/delete-files", { files, type }).then((res) => res);

export const uploadFile = (url, file) => {
  //This setting disables the browser from sending cookies and credentials with cross-site requests
  axios.defaults.withCredentials = false;
  return axios.put(url, file, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}
